import React, {useState} from 'react';
import './DashboardTypeScl.scss';
import {useNavigate} from "react-router-dom";
import {
  BarChart,
  CartesianGrid,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Sector,
  XAxis,
  YAxis
} from "recharts";
import {Tooltip} from "chart.js";
import {Bar} from "react-chartjs-2";

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value} = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={"none"} fill="none"/>
      <circle cx={ex} cy={ey} r={2} fill={"none"} stroke="none"/>
      <text x={ex + (cos >= 0 ? 1 : -1) * 15} y={ey} textAnchor={textAnchor} fill="#333">{`${value}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 18} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(${(percent * 100).toFixed(1)}%)`}
      </text>
    </g>
  );
};

const DashboardTypeScl = (props) => {

  const [activeIndex, setActiveIndex] = useState(0);

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const navigateTo = useNavigate();
  const shortCut = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M16 12.9v4.2c0 3.5-1.4 4.9-4.9 4.9H6.9C3.4 22 2 20.6 2 17.1v-4.2C2 9.4 3.4 8 6.9 8h4.2c3.5 0 4.9 1.4 4.9 4.9z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M22 6.9v4.2c0 3.5-1.4 4.9-4.9 4.9H16v-3.1C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2h4.2C20.6 2 22 3.4 22 6.9z"
    ></path>
  </svg>

  return (
    <div className="scl-main-dash">

      {props?.dashboardComponentData?.shortcuts.length > 0 &&
        <ul className={"short-cut-list"}>
          {props?.dashboardComponentData?.shortcuts.map((v, index) => (
            <li key={"shortcut_" + index} className={"box-short-cut"} onClick={() => navigateTo(v?.url)}>
              {shortCut}
              <h6>{v?.title}</h6>
            </li>
          ))}
        </ul>
      }

      <ul className={"show-detail"}>
        <li style={{background: "#24B9C2"}}>
          <h6>ورودی کالا</h6>
          <h5>{props?.dashboardComponentData?.detail?.productInlet}</h5>
        </li>
        <li style={{background: "#4BD55E"}}>
          <h6>خروجی کالا</h6>
          <h5>{props?.dashboardComponentData?.detail?.productOutlet}</h5>
        </li>
        <li style={{background: "#E49627"}}>
          <h6>میزان کسری بار</h6>
          <h5>{props?.dashboardComponentData?.detail?.reduction}</h5>
        </li>
        <li style={{background: "#F6587C"}}>
          <h6>تعداد راننده</h6>
          <h5>{props?.dashboardComponentData?.detail?.numberOfDrivers}</h5>
        </li>
      </ul>


      <div className={"chart-side"}>

        <div className="main-product-barcode">
          <div className="title-box">
            <p>گزارش تحویل براساس زمان</p>
          </div>

          <div style={{width: '99%'}}>
            <ResponsiveContainer width={"99%"} height={250}>
              <LineChart
                width={'100%'}
                height={260}
                data={props?.dashboardComponentData?.chart_1}
                margin={{
                  top: 20,
                  right: 40,
                  left: 0,
                  bottom: 0,
                }}>
                <CartesianGrid strokeDasharray="3 3"/>
                <XAxis dataKey="name"/>
                <YAxis/>
                <Tooltip/>
                <Line connectNulls type="monotone" dataKey="uv" stroke="#D443A2" fill="#D443A2"/>
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>


        <div className="pie-chart-side">
          <div className="title-box">
            <p>گزارش میزان تحویل براساس محصول</p>
          </div>
          <ResponsiveContainer width="99%" height="85%">
            <PieChart width={'100%'} height={300}>
              <Pie
                activeIndex={activeIndex}
                activeShape={renderActiveShape}
                data={props?.dashboardComponentData?.chart_2}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                fill="#50a4f5"
                dataKey="value"
                onMouseEnter={onPieEnter}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>

      </div>
    </div>
  );
};

export default DashboardTypeScl;